import { PriceType } from '../../../models/priceData/priceData';
import { failSilently } from '../../utils/failSilently';
import { sendGA4Event } from '../shared/sendGa4Event';

const vatSelectionClick = (priceType: PriceType) => {
    let clickText;

    if (priceType === PriceType.IncludeTax) {
        clickText = 'inklusive moms' as const;
    }

    if (priceType === PriceType.ExcludeTax) {
        clickText = 'exklusive moms' as const;
    }

    if (!clickText) {
        return;
    }

    sendGA4Event({
        event: 'interaction',
        type: 'vat selection',
        click_text: clickText,
        event_key: 'vat_interaction',
    });
};

const b2bCrossContextPopupInteraction = (clickText: string) => {
    sendGA4Event({
        event: 'interaction',
        type: 'pop-up',
        click_text: clickText.toLowerCase(),
        event_key: 'popup_wrong_account_interaction',
    });
};

export default {
    vatSelectionClick: failSilently(vatSelectionClick),
    b2bCrossContextPopupInteraction: failSilently(b2bCrossContextPopupInteraction),
};
